import { ISettingsApi } from '@/features/shared/ISettingsApi';
import { inject, injectable } from 'inversify-props';
import { AxiosId } from '@/plugins/axios';
import { AxiosInstance } from 'axios';
import { Settings } from '@/features/shared/models/Settings';
import { IAppConfig, IAppConfigId } from '@/features/shared/IAppConfig';

@injectable()
export class SettingsApi implements ISettingsApi {
    @inject(IAppConfigId)
    config!: IAppConfig;

    @inject(AxiosId)
    axios!: AxiosInstance;

    getSettings(): Promise<Settings> {
        return new Promise<Settings>((resolve, reject) => {
            this.axios
                .get<Settings>('/api/settings/getsettings', {
                    params: {
                        token: this.config.token
                    }
                })
                .then(response => {
                    const settings: Settings = response.data;
                    resolve(settings);
                })
                .catch(exception => {
                    reject(exception);
                });
        });
    }
}
